import axios from 'axios';
import { from } from 'rxjs';
import { LogService } from '../services/log-service';

export const getDeliveryOptionsResults = (quoteId, storeGuid) => {
  const getResults = axios.get(`/deliveryoptions/${storeGuid}/rates/${quoteId}`).then((response) => {
    const { data } = response;
    return data;
  });
  return from(getResults);
};

export const getDeliveryOptionsDynamoResults = async (quoteId, storeGuid) => {
  try {
    const response = await axios.get(`deliveryoptions/${storeGuid}/quotes/${quoteId}`);
    const result = response?.data ?? [];
    return result;
  } catch (e) {
    LogService.logError(new Error('Error fetching delivery options details', { cause: e }));
  }
};
